"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.actionTypes = void 0;
var actionTypes = {
  // common
  UNIQUE_MAIL: "@@recipient/unique_mail",
  UNIQUE_MAIL_RESET: "@@recipient/unique_mail_reset",
  UNIQUE_REFERENCE_NO: "@@recipient/unique_reference_no",
  UNIQUE_REFERENCE_NO_RESET: "@@recipient/unique_reference_no_reset",
  LIST: "@@recipient/list",
  LIST_LINK: "@@recipient/list-link",
  LIST_SEARCH: "@@recipient/list-search",
  CREATE: "@@recipient/create",
  SET_FUND_ID_LIST: "@@recipient/set_fund_id_list",
  UPDATE: "@@recipient/update",
  LINKED_FUND: "@@recipient/linked_fund",
  LINKED_FUND_RESET: "@@recipient/linked_fund_reset",
  SAVE_LINKED_FUND: "@@recipient/save_linked_fund",
  SAVE_LINKED_FUND_RESET: "@@recipient/save_linked_fund_reset",
  LOCK: "@@recipient/lock",
  LOCK_BULK: "@@recipient/lock_bulk",
  UNLOCK: "@@recipient/unlock",
  UNLOCK_BULK: "@@recipient/unlock_bulk",
  SOFT_DELETE: "@@recipient/soft_delete",
  SOFT_DELETE_BULK: "@@recipient/soft_delete_bulk",
  SUBMIT: "@@recipient/submit",
  SUBMIT_BULK: "@@recipient/submit_bulk",
  APPROVE: "@@recipient/approve",
  APPROVE_BULK: "@@recipient/approve_bulk",
  COPY_URL: "@@recipient/copy_url",
  DOWNLOAD: "@@recipient/download",
  DOWNLOAD_ALL: "@@recipient/download_all",
  DOWNLOAD_SURVEY_RESPONSE: "@@recipient/download_survey_response",
  // deleted data
  SOFT_DELETE_LIST: "@@recipient/soft_delete_list",
  RESTORE: "@@recipient/restore",
  RESTORE_BULK: "@@recipient/restore_bulk",
  DELETE: "@@recipient/delete",
  DELETE_BULK: "@@recipient/delete_bulk",
  // Uploader
  PREFIGHT: "@@recipient/prefight",
  IMPORT: "@@recipient/import",
  ERROR_SHEET_DOWNLOAD: "@@recipient/error_sheet_download",
  GET_SURVEY_RECIPENT_RESPONSE: "@@recipient/get_survey_recipent_response",
  // link
  CHECK_RECIPIENT: "@@recipient/check_recipient",
  CHECK_SURVEY: "@@recipient/check_survey",
  LINK_SURVEY_AND_RECIPIENT_RESPONSE: "@@recipient/link_survey_and_recipient_response",
  LINK_SURVEY_AND_RECIPIENT_RESPONSE_RESET: "@@recipient/link_survey_and_recipient_response_reset",
  LINK_SINGLE_SOFT_DELETE: "@@recipient/link_single_soft_delete",
  LINK_SINGLE_SOFT_DELETE_BULK: "@@recipient/link_single_soft_delete_bulk",
  LIST_UNPAGED: "@@user/list-status",
  // response
  SURVEY_CONFIGURATION_FETCH_RESPONSE: "@@survey-render/survey-configuration-fetch-response",
  SURVEY_CONFIGURATION_FETCH_RESPONSE_RESET: "@@survey-render/survey-configuration-fetch-response-reset",
  SURVEY_CONFIGURATION_SAVE_RESPONSE: "@@survey-render/survey-configuration-save-response",
  SURVEY_CONFIGURATION_SAVE_RESET_RESPONSE: "@@survey-render/survey-configuration-save-reset-response",
  // default
  RESET: "@@recipient/reset",
  SUCCESS: "@@recipient/success",
  ERROR: "@@recipient/error"
};
exports.actionTypes = actionTypes;